<!--
 Component for controlling filters registered in a `SelectFilterStore`.
 Check the store for more details on how they should be used together.
-->
<template>
  <div v-if="hasItems || !hideIfEmpty" class="select-filter-container mw-100">
    <ue-select
      :options="getFilterOptions(name)"
      @input="handleSelect"
      :disabled="!hasItems"
      :placeholder="this.placeholder()"
      labelField="text"
      keyField="value"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useSelectFilterStore } from '@app/stores/tables/SelectFilterStore'
import from_query_params from '@app/mixins/from_query_params'
import to_query_params from '@app/mixins/to_query_params'

export default {
  name: 'SelectFilter',
  mixins: [from_query_params, to_query_params],

  props: {
    name: {
      type: String,
      required: true,
    },
    hideIfEmpty: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.fromQueryParams(this.$router, useSelectFilterStore(), this.name)
  },

  computed: {
    ...mapState(useSelectFilterStore, ['getFilterOptions', 'getSelectedOption']),
    hasItems() {
      return this.getFilterOptions(this.name).length > 0
    },
  },

  methods: {
    handleSelect(option) {
      useSelectFilterStore().setSelectedOption(this.name, option.value)
      this.toQueryParams(this.$router, this.name, option.value)
    },

    placeholder() {
      if (!this.hasItems) {
        return 'No options available'
      }

      const filterOptions = this.getFilterOptions(this.name)

      const selectedOptionValue = this.getSelectedOption(this.name)
      if (selectedOptionValue) {
        const option = filterOptions.find((option) => option.value == selectedOptionValue)
        return option ? option.text : 'No options available'
      } else {
        return filterOptions.length > 0 ? filterOptions[0].text : 'No options available'
      }
    },
  },
}
</script>
